<template>
  <b-container>
    <b-row class="schedule-content" align-h="center">
      <b-col>
        <b-row>
          <b-col>
            <select class="timezone-select" v-model="currentTimeZone">
              <option v-bind:value="timeZone" v-for="timeZone in timeZones" :key="timeZone">{{ timeZone }}</option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button v-on:click="weekShift -= 1">Prev</b-button>
          </b-col>
          <b-col class="timezone-select-container">
            <p class="text-center">Week of {{ this.startOfWeek | moment("ddd, MMM Do") }}</p>
          </b-col>
          <b-col>
            <b-button class="float-right" v-on:click="weekShift += 1">Next</b-button>
          </b-col>
        </b-row>
        <!--
        <b-row>
          <b-col>
            <b-nav fill tabs>
              <b-nav-item active>Sun</b-nav-item>
              <b-nav-item v-on:click="hasEvents">Mon</b-nav-item>
              <b-nav-item>Tue</b-nav-item>
              <b-nav-item>Wed</b-nav-item>
              <b-nav-item>Thu</b-nav-item>
              <b-nav-item>Fri</b-nav-item>
              <b-nav-item>Sat</b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
        -->
        <b-row>
          <b-container class="event-grid">
            <b-row v-bind:class="getEventRowClass(ev.start.dateTime, ev.end.dateTime)" class="event-row" v-for="ev in events" :key="ev.id">
              <b-col>{{ ev.summary }}</b-col>
              <b-col>{{ getDateInCurrentTimeZone(ev.start.dateTime) | moment("ddd, MMM Do[:] h:mm A") }} - {{ getDateInCurrentTimeZone(ev.end.dateTime) | moment("h:mm A") }}</b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data () {
    return {
      events: null,
      timeZones: null,
      currentTimeZone: null,
      weekShift: 0
    }
  },
  computed: {
    hasEvents: function() {
      return (this.events != null);
    },
    startOfWeek: function () {
      return this.$moment()
        .add(this.weekShift, 'weeks')
        .startOf('week')
        .tz(this.currentTimeZone)
        .format();
    },
    endOfWeek: function () {
      return this.$moment()
        .add(this.weekShift, 'weeks')
        .endOf('week')
        .tz(this.currentTimeZone)
        .format();
    }
  },
  watch: {
    currentTimeZone: function() {
      this.refreshEvents();
    },
    weekShift: function() {
      this.refreshEvents();
    }
  },
  created: function() {
    this.timeZones = this.getTimeZoneNames();
    this.currentTimeZone = this.guessTimezone();
  },
  methods: {
    getEventRowClass(eventStartDate, eventEndDate) {
      if (this.isCurrentEvent(eventStartDate, eventEndDate)) {
        return "event-current";
      } else if (this.isFutureEvent(eventEndDate)) {
        return "event-future";
      } else {
        return "event-past";
      }
    },
    getCurrentDateTime() {
      return this.getDateInCurrentTimeZone(this.$moment());
    },
    isCurrentEvent(eventStartDate, eventEndDate) {
      return this.getCurrentDateTime().isBetween(eventStartDate, eventEndDate);
    },
    isFutureEvent(eventEndDate) {
      return this.getCurrentDateTime().isBefore(eventEndDate);
    },
    getDateInCurrentTimeZone: function (date) {
      return this.$moment(date).tz(this.currentTimeZone);
    },
    guessTimezone: function () {
      return this.$moment.tz.guess();
    },
    getTimeZoneNames: function() {
      return this.$moment.tz.names();
    },
    refreshEvents: function() {
      this.$http.get('https://www.googleapis.com/calendar/v3/calendars/empdotcx@gmail.com/events', {
        params: {
          key: 'AIzaSyDHJqGFux_nJ5ePpVvX60ww7mvfdnFxlh8',
          singleEvents: true,
          orderBy: 'startTime',
          timeMin: this.startOfWeek,
          timeMax: this.endOfWeek,
          timeZone: this.currentTimeZone,
          maxResults: 25
        }
      })
      .then(response => {
        this.events = response.data.items;
      })
    }
  }
};
</script>

<style lang="scss">

  .schedule-content {
    padding-top: 15px;
    font-size: 1rem;
  }

  .btn {
    font-size: 100%;
  }

  .timezone-select {
    width: 100%;
  }

  .event-grid {
    padding-top: 20px;
  }
  .event-row {
    margin-left: 5px;
    margin-right: 5px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #fff;
    
  }

  .event-row.event-past {
    color: grey;
    font-style: italic;
  }

  .event-row.event-current {
    color: green;
  }
/*
  .nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    background-color: #bf2026;
  }

  .card-header {
    background-color: #000000;
  }
  
  .card {
    background-color: transparent;
  }
  */
@media (min-width: 576px) {
  .schedule-content {
    font-size: 1rem;
  }
}

@media (min-width: 768px) {
  .schedule-content {
    font-size: 1.25rem;
  }
}

@media (min-width: 992px) {
  .schedule-content {
    font-size: 1.75rem;
  }
}

@media (min-width: 1200px) {
  .schedule-content {
    font-size: 2rem;
  }
}


</style>


// WEBPACK FOOTER //
// src/Schedule.vue